"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicePermissions = void 0;
var ServicePermissions;
(function (ServicePermissions) {
    ServicePermissions["ANONYMOUS"] = "anonymous";
    ServicePermissions["APPLICATIONS_READ"] = "applications.read";
    ServicePermissions["APPLICATIONS_WRITE"] = "applications.write";
    ServicePermissions["AUDIT_READ"] = "audit.read";
    ServicePermissions["BOOKED_SUBSCRIPTION_WRITE"] = "bookedsubscriptions.write";
    ServicePermissions["CALENDAR_READ"] = "calendar.read";
    ServicePermissions["CALENDAR_WRITE"] = "calendar.write";
    ServicePermissions["CMS_READ"] = "cms.read";
    ServicePermissions["CMS_WRITE"] = "cms.write";
    ServicePermissions["CONFIGURATION_READ"] = "configuration.read";
    ServicePermissions["CONFIGURATION_WRITE"] = "configuration.write";
    ServicePermissions["CONTACTS_READ"] = "contacts.read";
    ServicePermissions["CONTACTS_WRITE"] = "contacts.write";
    ServicePermissions["CONTACTS_ADMIN"] = "contacts.admin";
    ServicePermissions["CRONJOB_READ"] = "cronjob.read";
    ServicePermissions["CRONJOB_WRITE"] = "cronjob.write";
    ServicePermissions["DATA_READ"] = "data.read";
    ServicePermissions["DATA_TEMPLATES_WRITE"] = "datatemplates.write";
    ServicePermissions["DATA_WRITE"] = "data.write";
    ServicePermissions["DATATYPES_WRITE"] = "datatypes.write";
    ServicePermissions["DEVICES_READ"] = "devices.read";
    ServicePermissions["DEVICES_WRITE"] = "devices.write";
    ServicePermissions["EMAILS_READ"] = "emails.read";
    ServicePermissions["EMAILS_SEND"] = "emails.send";
    ServicePermissions["EMAILS_WRITE"] = "emails.write";
    ServicePermissions["EMAILTEMPLATES_READ"] = "emailtemplates.read";
    ServicePermissions["EMAILTEMPLATES_WRITE"] = "emailtemplates.write";
    ServicePermissions["EXPORTERS_EXECUTE"] = "exporters.execute";
    ServicePermissions["EXPORTERS_READ"] = "exporters.read";
    ServicePermissions["FILES_READ"] = "files.read";
    ServicePermissions["FILES_WRITE"] = "files.write";
    ServicePermissions["FORMS_WRITE"] = "forms.write";
    ServicePermissions["IMPORTERS_EXECUTE"] = "importers.execute";
    ServicePermissions["IMPORTERS_READ"] = "importers.read";
    ServicePermissions["INTERNATIONALIZATION_READ"] = "internationalization.read";
    ServicePermissions["INTERNATIONALIZATION_WRITE"] = "internationalization.write";
    ServicePermissions["MAILING_LIST_READ"] = "mailinglist.read";
    ServicePermissions["MAILING_LIST_WRITE"] = "mailinglist.write";
    ServicePermissions["MAILING_CHANNEL_READ"] = "mailingchannel.read";
    ServicePermissions["MAILING_CHANNEL_WRITE"] = "mailingchannel.write";
    ServicePermissions["MAILING_DELIVERABLE_READ"] = "mailingdeliverable.read";
    ServicePermissions["MAILING_DELIVERABLE_WRITE"] = "mailingdeliverable.write";
    ServicePermissions["MESSAGES_READ"] = "messages.read";
    ServicePermissions["OPT_IN_WRITE"] = "optin.write";
    ServicePermissions["ORDERS_READ"] = "orders.read";
    ServicePermissions["ORDERS_WRITE"] = "orders.write";
    ServicePermissions["PDF_TEMPLATE_READ"] = "pdftemplates.read";
    ServicePermissions["PDF_TEMPLATE_WRITE"] = "pdftemplates.write";
    ServicePermissions["PERMISSION_READ"] = "permission.read";
    ServicePermissions["PRODUCTS_READ"] = "products.read";
    ServicePermissions["PRODUCTS_WRITE"] = "products.write";
    ServicePermissions["SHOPPING_CARTS_READ"] = "shoppingcarts.read";
    ServicePermissions["SHOPPING_CARTS_WRITE"] = "shoppingcarts.write";
    ServicePermissions["SUPPLIERS_READ"] = "suppliers.read";
    ServicePermissions["SUPPLIERS_WRITE"] = "suppliers.write";
    ServicePermissions["SUBSCRIPTIONS_WRITE"] = "subscriptions.write";
    ServicePermissions["TASKS_READ"] = "tasks.read";
    ServicePermissions["TASKS_WRITE"] = "tasks.write";
    ServicePermissions["TASKS_EXECUTE"] = "tasks.execute";
    ServicePermissions["TENANT_ADMIN"] = "tenant.admin";
    ServicePermissions["TENANT_READ"] = "tenant.read";
    ServicePermissions["TENANT_WRITE"] = "tenant.write";
    ServicePermissions["USERS_READ"] = "users.read";
    ServicePermissions["USERS_WRITE"] = "users.write";
    ServicePermissions["WORKFLOW_EXECUTE"] = "workflow.execute";
    ServicePermissions["WORKFLOW_READ"] = "workflow.read";
    ServicePermissions["WORKFLOW_WRITE"] = "workflow.write";
    ServicePermissions["RESELLERS_ADMIN"] = "resellers.admin";
    ServicePermissions["RESELLER_WRITE"] = "reseller.write";
    ServicePermissions["RESELLER_READ"] = "reseller.read";
    ServicePermissions["TODO_WRITE"] = "todo.write";
    ServicePermissions["TODO_READ"] = "todo.read";
    ServicePermissions["TODO_OWNER_WRITE"] = "todo.owner.write";
    ServicePermissions["TODO_OWNER_READ"] = "todo.owner.read";
    ServicePermissions["TODO_TEMPLATE_WRITE"] = "todotemplate.write";
    ServicePermissions["TODO_TEMPLATE_READ"] = "todotemplate.read";
    ServicePermissions["TODO_TEMPLATE_OWNER_WRITE"] = "todotemplate.owner.write";
    ServicePermissions["TODO_TEMPLATE_OWNER_READ"] = "todotemplate.owner.read";
    ServicePermissions["WORKLOG_READ"] = "worklog.read";
    ServicePermissions["WORKLOG_WRITE"] = "worklog.write";
    ServicePermissions["WORKLOG_OWNER_READ"] = "worklog.owner.read";
    ServicePermissions["WORKLOG_OWNER_WRITE"] = "worklog.owner.write";
})(ServicePermissions = exports.ServicePermissions || (exports.ServicePermissions = {}));
